export default (state, action) => {
  switch (action.type) {
    case "LOG_IN":
      localStorage.setItem("userInfoData", JSON.stringify(action.payload));
      return { ...state, userInfo: action.payload };
    case "LOG_OUT":
      localStorage.removeItem("userInfoData");
      return { ...state, userInfo: null, isVip: false, messageData: null };
    case "UPDATE_IS_VIP":
      if (action.payload && window.$) {
        // [WARN] 隐藏 VIP 用户的升级按钮
        window.$("#upGradeIconBtn, .upGradeIconBtn").hide();
      }
      return {
        ...state,
        isVip: action.payload
      };
    case "UPDATE_MESSAGE_DATA":
      return {
        ...state,
        messageData: action.payload
      };
    case "TOGGLE_HEADER_STYLE":
      return {
        ...state,
        isWhiteHeader: action.payload
      };
    case "SCRIPT_LOADED":
      return {
        ...state,
        isScriptLoaded: true
      };
    case "UPDATE_SCREEN_SIZE":
      return {
        ...state,
        isLargeScreen: action.payload
      };
    case "SHOW_AUTH_MODAL":
      return {
        ...state,
        showAuthModal: action.showAuthModal
      };
    case "SIGNTYPE":
      return {
        ...state,
        signType: action.signType
      };
    default:
      return state;
  }
};
